import React from 'react'
import styled from 'styled-components/native'

import { CulturalSurveyProgressBar } from 'features/culturalSurvey/components/CulturalSurveyProgressBar'
import { homeNavigationConfig } from 'features/navigation/TabBar/helpers'
import { useGoBack } from 'features/navigation/useGoBack'
import { TouchableOpacity } from 'ui/components/TouchableOpacity'
import { ArrowPrevious as DefaultArrowPrevious } from 'ui/svg/icons/ArrowPrevious'
import { Typo } from 'ui/theme'
import { getTextSemanticAttrs } from 'ui/theme/typographyAttrs/getTextSemanticAttrs'

interface Props {
  title: string
  progress: number
  onGoBack?: () => void
}

export const CulturalSurveyPageHeader: React.FC<Props> = (props) => (
  <HeaderContainer>
    <BackIcon onGoBack={props.onGoBack} />
    <BarAndTitle>
      <BarContainer>
        <CulturalSurveyProgressBar progress={props.progress} />
      </BarContainer>
      <Title>{props.title}</Title>
    </BarAndTitle>
  </HeaderContainer>
)

const HeaderContainer = styled.View(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  height: theme.appBarHeight,
}))

const BarAndTitle = styled.View(({ theme }) => ({
  flexDirection: 'row',
  marginLeft: theme.designSystem.size.spacing.xxxxl,
  justifyContent: 'space-between',
  flex: 1,
}))

const Title = styled(Typo.Title4).attrs(() => ({ ...getTextSemanticAttrs(1), numberOfLines: 1 }))(
  ({ theme }) => ({
    flex: 1,
    marginRight: theme.designSystem.size.spacing.xl,
    textAlign: 'right',
  })
)

interface BackButtonProps {
  onGoBack?: () => void
}

const BackIcon: React.FC<BackButtonProps> = (props) => {
  const { goBack } = useGoBack(...homeNavigationConfig)
  return (
    <StyledTouchableOpacity
      onPress={props.onGoBack ?? goBack}
      accessibilityLabel="Revenir en arrière">
      <ArrowPrevious testID="icon-back" />
    </StyledTouchableOpacity>
  )
}

const BarContainer = styled.View(({ theme }) => ({
  flex: 1,
  marginRight: theme.designSystem.size.spacing.xl,
}))

const ArrowPrevious = styled(DefaultArrowPrevious).attrs(({ theme }) => ({
  size: theme.designSystem.size.icon.m,
}))``

const StyledTouchableOpacity = styled(TouchableOpacity)(({ theme }) => ({
  position: 'absolute',
  left: theme.designSystem.size.spacing.m,
}))
